import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export function labelClassName(className?: string) {
  return cn('label-sm', className);
}

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label ref={ref} className={labelClassName(className)} {...props} />
  ),
);
Label.displayName = 'Label';
